import { render, staticRenderFns } from "./AlterarDataVenda.vue?vue&type=template&id=25903fe4&scoped=true&"
import script from "./AlterarDataVenda.vue?vue&type=script&setup=true&lang=js&"
export * from "./AlterarDataVenda.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AlterarDataVenda.vue?vue&type=style&index=0&id=25903fe4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25903fe4",
  null
  
)

export default component.exports